__turbopack_export_value__({
  "active": "OrderScreen-module__Y6zbJG__active",
  "card": "OrderScreen-module__Y6zbJG__card",
  "card__button": "OrderScreen-module__Y6zbJG__card__button",
  "card__header": "OrderScreen-module__Y6zbJG__card__header",
  "card__order": "OrderScreen-module__Y6zbJG__card__order",
  "closeBtn": "OrderScreen-module__Y6zbJG__closeBtn",
  "container": "OrderScreen-module__Y6zbJG__container",
  "courierItem": "OrderScreen-module__Y6zbJG__courierItem",
  "couriersList": "OrderScreen-module__Y6zbJG__couriersList",
  "errorMessage": "OrderScreen-module__Y6zbJG__errorMessage",
  "footer": "OrderScreen-module__Y6zbJG__footer",
  "footer__nav": "OrderScreen-module__Y6zbJG__footer__nav",
  "header": "OrderScreen-module__Y6zbJG__header",
  "header__content": "OrderScreen-module__Y6zbJG__header__content",
  "header__title": "OrderScreen-module__Y6zbJG__header__title",
  "item__comment": "OrderScreen-module__Y6zbJG__item__comment",
  "item__quantity": "OrderScreen-module__Y6zbJG__item__quantity",
  "logoutButton": "OrderScreen-module__Y6zbJG__logoutButton",
  "main": "OrderScreen-module__Y6zbJG__main",
  "modalBackdrop": "OrderScreen-module__Y6zbJG__modalBackdrop",
  "modalBody": "OrderScreen-module__Y6zbJG__modalBody",
  "modalContent": "OrderScreen-module__Y6zbJG__modalContent",
  "modalFooter": "OrderScreen-module__Y6zbJG__modalFooter",
  "modalHeader": "OrderScreen-module__Y6zbJG__modalHeader",
  "order__address": "OrderScreen-module__Y6zbJG__order__address",
  "order__btn": "OrderScreen-module__Y6zbJG__order__btn",
  "order__item": "OrderScreen-module__Y6zbJG__order__item",
  "order__item__btn": "OrderScreen-module__Y6zbJG__order__item__btn",
  "order__meta": "OrderScreen-module__Y6zbJG__order__meta",
  "order__screen": "OrderScreen-module__Y6zbJG__order__screen",
  "ordersContainer": "OrderScreen-module__Y6zbJG__ordersContainer",
  "searchContainer": "OrderScreen-module__Y6zbJG__searchContainer",
  "searchInput": "OrderScreen-module__Y6zbJG__searchInput",
});
